import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import Grid from '../../components/Grid';
import Button from '../../components/Button';
import './styles.css';

const isEmptyObject = (obj) => Object.keys(obj).reduce((acc, key) => (acc && obj[key] === undefined), true);
const errorsExist = (errors) =>
  errors && (!isEmptyObject(omit(errors, 'requiredFieldsMissing')) || errors.requiredFieldsMissing.length > 0);

const ButtonSet = ({ index, onSave, onCancel, onDelete, canSave, saving, errors }) => (
  <React.Fragment>
    <Grid.Row>
      <Grid.Column width={2}>
        <Button
          key={`merit-scholarships-delete-button-${index}`}
          data-cy="merit-scholarships-delete-button"
          aria-label="Click to delete scholarship"
          negative
          basic
          onClick={onDelete}
          tabIndex={0}
        >
          Delete
        </Button>
      </Grid.Column>
      <Grid.Column width={14}>
        <Button
          key={`merit-scholarships-save-button-${index}`}
          data-cy="merit-scholarships-save-button"
          aria-label="Click to save changes to scholarship"
          primary
          styleName="merit-scholarships-form-buttons-save"
          onClick={onSave}
          tabIndex={0}
          disabled={errorsExist(errors) || !canSave}
          loading={saving}
        >
          Save
        </Button>
        <Button
          key={`merit-scholarships-cancel-button-${index}`}
          data-cy="merit-scholarships-cancel-button"
          aria-label="Click to cancel changes to scholarship"
          styleName="merit-scholarships-form-buttons-cancel"
          onClick={onCancel}
          tabIndex={0}
        >
          Cancel
        </Button>
      </Grid.Column>
    </Grid.Row>
  </React.Fragment>
);

ButtonSet.propTypes = {
  index: PropTypes.string,
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
  onSave: PropTypes.func,
  canSave: PropTypes.bool,
  saving: PropTypes.bool,
  errors: PropTypes.shape({
    requiredFieldsMissing: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default ButtonSet;
